<template>
  <div ref="scrollparent">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-card v-if="sequence">
      <!-- <pre>answer id : {{ this.$route.params.answerid }}</pre>
      <pre>collaborator key : {{ this.$route.params.collaboratorid }}</pre>
      <pre>collab key : {{ this.$route.params.key }}</pre> -->

      <!-- <pre>{{sequence}}</pre> -->

      <v-row wrap class="mb-5">

        <!-- Header Title && Firm -->
        <v-col cols="12" md="5">
          <h1
            class="mb-4"
            v-html="sequence.info[`title_${lang}`]"
          ></h1>
          <template v-if="sequence && sequence.info">
            <IDLessCard
              :title="sequence.info.firm_name"
              :address="sequence.info.firm_address"
              :city="sequence.info ? sequence.info.firm_city : null"
              :zip="sequence.info ? sequence.info.firm_zip : null"
            ></IDLessCard>
          </template>
          <template v-else><IDLessCard></IDLessCard></template>
        </v-col>
        <!-- Survey score -->
        <v-col cols="12" md="7">
          <SurveyHeaderScore :survey="sequence"></SurveyHeaderScore>
        </v-col>

      </v-row>

      <v-row wrap class="mb-5">
        <v-col
          v-if="content && content.length > 0"
          cols="12"
          md="5"
          order-md="2"
          v-scroll="onScroll"
          ref="sticky"
          class="sticky-nav"
        >
          <div class="box">
            <v-layout
              d-block
              d-md-flex
              row
              ma-0
              align-center
              justify-space-between
              class="box-header px-5 px-md-6"
            >
              <template v-for="(item, index) in content">
                <h3 v-if="item.type === 'title' && item.text" :key="index" v-html="item.text"></h3>
              </template>
            </v-layout>
            <div class="box-content flex px-6 px-md-8">
              <template v-for="(item, index) in content">
                <p v-if="item.type === 'text' && item.text" :key="index" v-html="item.text"></p>
              </template>

              <v-btn
                class="ma-2"
                rounded
                elevation="0"
                medium
                color="primary"
                @click="finishDelegate"
                :disabled="sequence.total.mandatoryq > sequence.done.mandatoryq"
                >{{ $t("validate-audit.finish-btn") }}</v-btn>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="7">
          <!-- <transition-group name="fade"> -->
            <DelegateQuestionViews
              v-for="quest in sequence.questions"
              :key="quest.id"
              :question="quest"
              :collaboratorid="$route.params.collaboratorid"
              :collaborationkey="$route.params.key"
              :answerid="$route.params.answerid"
              @updateSurveySequenceScore="updateSurveyHeader"
            ></DelegateQuestionViews>
          <!-- </transition-group> -->
        </v-col>
      </v-row>
    </v-card>

    <!-- <QuestionBlock questionType="all" :keywords="$route.params.sequenceid"></QuestionBlock> -->
  </div>
</template>

<script>
import { delegateSequence } from '@/js/delegate/delegateSequence'
import { delegateFinish } from '@/js/delegate/delegateFinish'
import { getStatic } from '@/js/static/getStatic'
import IDLessCard from '@/components/firm/IDLessCard'
import SurveyHeaderScore from '@/components/audits/SurveyHeaderScore'
import DelegateQuestionViews from '@/components/audits/delegate/DelegateQuestionViews'
import QuestionBlock from '@/components/questions/QuestionBlock'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    IDLessCard: IDLessCard,
    SurveyHeaderScore: SurveyHeaderScore,
    DelegateQuestionViews: DelegateQuestionViews,
    QuestionBlock: QuestionBlock,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      sequence: null,
      firm: null,
      httpalert: false,

      lang: (this.$i18n.locale == 'en-EN') || (this.$i18n.locale == 'en') ? 'en' :
            (this.$i18n.locale == 'fr-FR') || (this.$i18n.locale == 'fr') ? 'fr' :
            (this.$i18n.locale == 'nl-NL') || (this.$i18n.locale == 'nl') ? 'nl' : 'fr',
      
      content: null
    }
  },

  async created () {
    await this.loadSeq()

    const paramsContent = {
      lang: this.$i18n.locale ? this.$i18n.locale : 'fr',
      page: 'task',
      keyword: 'explication'
    }
    getStatic(paramsContent)
      .then(response => this.content = response.modules)
      // .catch(error => console.log(error))
  },

  methods: {
    async loadSeq() {
      if (this.$route.params.collaboratorid && this.$route.params.key) {
        const params = {
          collaboratorid: this.$route.params.collaboratorid,
          key: this.$route.params.key
        }
        await delegateSequence(params)
          .then(response => {
            if (response) {
              this.sequence = response
            } else { this.$router.push('/dashboard') }
          })
          .catch(() => {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          })
      }
    },

    onScroll () {
      if (this.$vuetify.breakpoint.name === 'xs' ||
          this.$vuetify.breakpoint.name === 'sm') {

        this.$refs.sticky.style.transform = 'translateY(0px)'
        return
      }
      // this.offsetTop = e.target.scrollTop
      const sticky = this.$refs.sticky
      const offsetTop = window.pageYOffset || document.documentElement.scrollTop

      if (offsetTop > sticky.offsetTop) {
        // console.log(this.$refs.scrollparent.offsetTop)
        if (((offsetTop - sticky.offsetTop - 100) + sticky.offsetHeight) >= (this.$refs.scrollparent.offsetHeight - 100)) return
        // (offsetTop - sticky.offsetTop - 100) + 
        sticky.style.transform = `translateY(${offsetTop - sticky.offsetTop - 100}px)`
      }
      else {
        sticky.style.transform = 'translateY(0px)'
      }
    },

    updateSurveyHeader() { this.loadSeq() },

    finishDelegate() {
      const params = {
        collaboratorid: this.$route.params.collaboratorid,
        key: this.$route.params.key
      }
      delegateFinish(params)
        .then(response => {
          if (response.status === 'ok') this.$router.push('/dashboard')
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
